import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './themes/theme';
import { createTheme } from '@mui/material';

const ThemeProviderWrapper = ({ children }) => {
	// @ts-ignore
	const customTheme = createTheme(theme);
	return (
		<ThemeProvider theme={customTheme}>
			{children}
		</ThemeProvider>
	);
};

export default ThemeProviderWrapper;